<template>
    <nav class="bi-navbar">
        <div class="container">
            <div class="logo d-none d-md-block">
                <router-link :to="{ name: 'bi-landing' }">
                    <img width="76px" src="@assets/img/insights-logo.png" alt="hibooks logo">
                </router-link>
            </div>
            <hb-dropdown class="mobile-nav-dropdown d-flex d-md-none" :is-icon="false" close-on-click>
                <template slot="btn">
                    <img src="@assets/img/insights-logo.png" width="76px" alt="hibooks logo">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path
                            fill="#505050"
                            fill-rule="evenodd"
                            d="M18.071 11.384l-5.364 5.364a1 1 0 0 1-1.414 0l-5.364-5.364a1 1 0 0 1 .707-1.707h10.728a1 1 0 0 1 .707 1.707z"
                        />
                    </svg>
                </template>
                <template slot="body">
                    <div class="mobile-nav-dropdown-body">
                        <div class="container">
                            <nav-links />
                            <div v-if="isLoggedIn && hasUserData" class="logged-user">
                                <div class="name">
                                    {{ userFirstName | titleCase }}
                                </div>
                                <div class="logout" @click="goToNonfictionProfile">
                                    My account
                                </div>
                                <div class="logout" @click="logout()">
                                    Logout
                                </div>
                            </div>
                            <not-logged-in v-else />
                        </div>
                    </div>
                </template>
            </hb-dropdown>
            <hb-dropdown
                v-if="$route.name != 'bi-landing'"
                class="tablet-nav-dropdown d-none d-md-flex d-lg-none"
                :is-icon="false"
                close-on-click
            >
                <template slot="btn">
                    {{ routeName }}
                    <svg width="18" height="18" viewBox="0 0 24 24">
                        <path
                            fill="#505050"
                            fill-rule="evenodd"
                            d="M18.071 11.384l-5.364 5.364a1 1 0 0 1-1.414 0l-5.364-5.364a1 1 0 0 1 .707-1.707h10.728a1 1 0 0 1 .707 1.707z"
                        />
                    </svg>
                </template>
                <template slot="body">
                    <div class="user-dropdown">
                        <nav-links />
                    </div>
                </template>
            </hb-dropdown>
            <nav-links v-if="$route.name != 'bi-landing'" class="d-none d-lg-flex" />
            <div class="user-bar d-none d-md-block">
                <template v-if="isLoggedIn && hasUserData">
                    <span class="user-bar__user-name">
                        <hb-dropdown :x="userDropdownCoordenates.x" :y="userDropdownCoordenates.y" close-on-click>
                            <template slot="btn">
                                <span class="mr-2 d-none d-lg-block">
                                    {{ userFirstName | titleCase }}
                                </span>
                            </template>
                            <template slot="body">
                                <div class="user-dropdown">
                                    <h1>Annual Member</h1>
                                    <ul>
                                        <li @click="goToNonfictionProfile">
                                            My account
                                        </li>
                                        <li @click="logout()">
                                            <span>Logout</span>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </hb-dropdown>
                    </span>
                </template>
                <not-logged-in v-else />
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import _isEmpty from "lodash/isEmpty";

export default {
    name: "NonFictionNavBar",
    components: {
        NavLinks: () => import(/* webpackChunkName: "nav-links"*/ "./nav-links"),
        NotLoggedIn: () => import(/* webpackChunkName: "not-logged-in"*/ "./not-logged-in")
    },
    data() {
        return {
            isDevelopment: process.env.NODE_ENV == "development",
            userDropdownCoordenates: {
                x: -70,
                y: 15
            },
            navLinks: {
                "bi-discover": "What's New",
                "bi-archive": "Featured Insights",
                "bi-library": "Library"
            }
        };
    },
    computed: {
        ...mapState({
            userCoins: state => state.UserWallet.coins,
            userFirstName: state => state.User.data.first_name || state.User.data.email,
            userProfileImage: state => state.User.data.image && state.User.data.image["100"]
        }),
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn",
            hasNonFictionSubscription: "UserMembership/hasNonFictionSubscription"
        }),
        hasUserData() {
            return !_isEmpty(this.$store.state.User.data);
        },
        routeName() {
            if (this.navLinks[this.$route.name]) {
                return this.navLinks[this.$route.name];
            } else {
                return this.navLinks["bi-discover"];
            }
        }
    },
    created() {
        this.handleUserDropdownCoordenates();
    },
    methods: {
        handleUserDropdownCoordenates() {
            if (window.innerWidth <= 768) {
                this.userDropdownCoordenates.x = -145;
            }
        },
        logout() {
            this.$store.dispatch("Application/showLoader", true);
            axios.post("/v2/logout").finally(() => this.clearSession());
        },
        async clearSession() {
            await Cookies.remove("token");
            await this.$store.dispatch("Application/resetGlobalData");
            await this.$store.dispatch("Application/showLoader", false);
            this.$store.dispatch("Application/setSelectedNonfictionGift", {});
            // await this.$router.push({ name: "bi-sign-in" });  this is handling by the App component
        },
        goToNonfictionProfile() {
            this.$store.dispatch("Application/setProfileGroup", "nonfiction");
            this.trackGTMEvent();
            this.$router.push({ name: "membership" });
        },
        trackGTMEvent() {
            const gtmEvent = {
                event: "bi-nav-allpages-myaccount",
                action: "myaccount"
            };
            this.$_gtmTrackEvent(gtmEvent);
        }
    }
}
</script>


<style lang="scss">
    .bi-navbar {
        padding: 12px 0;
        height: 84px;
        z-index: 20;
        position: fixed;
        width: 100%;
        background-color: #020202;
        box-shadow: 0 0 0 0 #edf2f1;
        transition: box-shadow .5s;
        border-bottom: 1px solid rgba(255, 255, 255, .25);

        >.container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 100%;

            .logo {
                display: flex;
                align-items: center;
                max-height: 50px;
                padding-right: 5px;

                a {
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                    font-size: 36px;
                    letter-spacing: -1.5px;
                    font-weight: 100;
                    color: $medium-gray;
                    line-height: 30px;
                    text-decoration: none;

                    img {
                        margin-right: 10px;
                    }
                }
            }

            .tablet-nav-dropdown {
                margin-right: auto;

                .bp-dropdown__btn {
                    padding: 8px;
                    color: $medium-gray;
                    font-size: 15px;
                    font-weight: 600;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: normal;
                    letter-spacing: 0.4px;
                    border-radius: 6px;
                }

                .bp-dropdown__body {
                    width: 230px;
                    right: initial;
                }
            }

            .mobile-nav-dropdown {
                width: 100%;

                .bp-dropdown__btn {
                    width: 100%;
                    display: flex;
                    font-size: 24px;
                    font-weight: 300;

                    img {
                        margin-right: 3px;
                    }

                    svg {
                        margin-left: 5px;
                    }

                    &--active {
                        background-color: transparent;
                    }
                }

                .bp-dropdown__body {
                    top: 84px !important;
                    left: 0 !important;
                    position: fixed;
                    border-radius: 0;
                    height: calc(100vh - 60px);
                    box-shadow: initial;
                    overflow: auto;

                    .container {
                        padding-left: 5px;
                        padding-right: 5px;
                    }

                    .nav-links {
                        width: 100%;

                        a {
                            padding: 22px 5px;
                            color: white;
                            border-bottom: 1px solid #eaeaea;

                            &:last-child {
                                border-bottom: 0;
                            }
                        }
                    }

                    .logged-user {
                        color: white;

                        .name {
                            padding: 0 5px;
                            padding-top: 22px;
                            padding-bottom: 10px;
                            font-size: 16px;
                            font-weight: normal;
                            font-style: normal;
                            font-stretch: normal;
                            line-height: normal;
                            letter-spacing: 0.4px;
                            border-top: 1px solid #eaeaea;
                        }

                        a {
                            padding: 0 5px;
                            padding-top: 10px;
                            padding-bottom: 22px;
                            font-size: 15px;
                            font-weight: 600;
                            font-style: normal;
                            font-stretch: normal;
                            line-height: normal;
                            letter-spacing: 0.4px;
                            color: inherit;
                            text-decoration: none;
                            display: block;
                            border-bottom: 1px solid #eaeaea;
                        }

                        .logout {
                            padding: 0 5px;
                            padding-top: 22px;
                            color: white;
                            font-size: 15px;
                            font-weight: 600;
                            font-style: normal;
                            font-stretch: normal;
                            line-height: normal;
                            letter-spacing: 0.4px;
                        }
                    }

                    .not-logged-in {
                        position: fixed;
                        bottom: 50px;
                        display: flex;
                        flex-direction: column;
                        padding-left: 0;
                        padding-right: 0;
                        width: 280px;
                        left: 50%;
                        transform: translateX(-50%);

                        * {
                            width: 100%;
                            text-align: center;
                            margin-bottom: 10px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }

                        a {
                            padding-left: 0;
                        }
                    }
                }
            }

            .user-bar {
                display: flex;
                align-items: center;

                &__profile-image {
                    width: 30px;
                    height: 30px;
                    border-radius: 100%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                &__user-name {
                    text-transform: uppercase;
                    font-weight: 500;

                    .bp-dropdown {
                        position: relative;
                        display: flex;
                        align-items: center;

                        .bp-dropdown__btn {
                            border: 0;
                            text-transform: initial;
                            font-size: 15px;
                            font-weight: 600;
                            background-color: transparent !important;

                            svg {
                                // margin-left: 10px;
                                transform: scale(1.5);
                            }
                        }

                        .bp-dropdown__body {
                            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
                            border-radius: 4px;
                            border: 1px solid #DCDCDC;
                            width: 218px;

                            .user-dropdown {
                                padding: 5px;

                                h1 {
                                    font-size: 15px;
                                    font-weight: 600;
                                    line-height: 19px;
                                    text-transform: initial;
                                    color: white;
                                }

                                ul {
                                    padding-left: 0;
                                    margin-bottom: 0;
                                    list-style: none;

                                    li {
                                        cursor: pointer;
                                        border-bottom: 1px solid $borders-color;
                                        padding: 10px 0;
                                        font-size: 15px;
                                        line-height: 19px;
                                        text-transform: initial;
                                        text-decoration: none;
                                        font-weight: 400;
                                        color: white;
                                        display: block;

                                        &:last-child {
                                            border: 0;
                                            padding-bottom: 0;
                                        }

                                        &:hover:not(:first-child) {
                                            font-weight: 500;
                                            border-bottom-width: 2px;
                                            border-color: $primary-color;
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }
</style>
